import { Box, Button, Typography } from '@mui/material'
import { FC } from 'react'
import { InformationModal } from 'utoniq-ui'

import { useTranslation } from '@/core'

export type EnableMembershipCardWarningModalProps = {
  open: boolean
  onClose: () => void
}

export const EnableMembershipCardWarningModal: FC<EnableMembershipCardWarningModalProps> =
  ({ open, onClose }) => {
    const { t } = useTranslation('consoleDigitalMembershipCard')

    return (
      <InformationModal
        open={open}
        onClose={onClose}
        title={t('enableSettingsWarningModalTitle')}
        innerSx={{
          width: 300,
        }}
        content={
          <>
            <Typography
              variant="subtitle1"
              sx={{
                fontSize: 13,
                fontWeight: 300,
              }}
            >
              {t('enableSettingsWarningDescription')}
            </Typography>

            <Box sx={{ mt: 2 }}>
              <Button variant="text" onClick={onClose}>
                {t('cancel')}
              </Button>
            </Box>
          </>
        }
      />
    )
  }
